import CalculateMembershipByEntryDateRequestModelBase from '../_generated/modelBases/calculate-membership-by-entry-date-request-model-base';

export default class CalculateMembershipByEntryDateRequestModel extends CalculateMembershipByEntryDateRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
